export const formatPrice = (price, precision, code = '') => (
  `${parseFloat(
    price * (10 ** -2) // we always have two decimals, so remove em!
  ).toFixed(
    precision // and then set new decimals based on provided precision
  )}${code ? ` ${code}` : ''}`
);

export const formatViewPrice = (price, precision) => {
  const [number, decimals] = price.split('.');
  if (price === '0') {
    return 0;
  }

  if (precision === 0) {
    return number;
  }

  if (!decimals) {
    return parseInt(number, 10).toFixed(precision);
  }

  const trimmedDecimals = decimals.substring(0, 2);

  if (decimals.length === 1) {
    return `${number}.${trimmedDecimals}${0}`;
  }

  return `${number}.${trimmedDecimals}`;
};

export const formatDbPrice = (price, precision) => {
  const [number, decimals] = price.split('.');

  if (price === '0') {
    return 0;
  }

  if (precision === 0) {
    return parseInt(number, 10).toFixed(2).replace('.', '');
  }

  if (!decimals) {
    return parseInt(number, 10).toFixed(2).replace('.', '');
  }

  const trimmedDecimals = decimals.substring(0, 2);

  if (decimals.length === 1) {
    return `${number}${trimmedDecimals}${0}`;
  }

  return `${number}${trimmedDecimals}`;
};
